import { PayloadAction } from 'typesafe-actions';
import { ActivityLogActionTypes, ActivityLogState } from './types';

const ActivityLogReducer = (
  state: ActivityLogState,
  action: PayloadAction<ActivityLogActionTypes, any>,
): ActivityLogState => {
  switch (action.type) {
    case ActivityLogActionTypes.GetActivityLogList:
      return {
        ...state,
        activityLogListData: action.payload,
      };

    case ActivityLogActionTypes.SetActivityLogListFilter:
      return {
        ...state,
        activityLogListFilters: action.payload,
      };

    case ActivityLogActionTypes.SetIsActivityFilterDrawerOpen:
      return {
        ...state,
        isActivityLogFilterDrawerOpen: action.payload,
      };

    case ActivityLogActionTypes.SetSelectedActivityLog:
      return {
        ...state,
        selectedActivityLog: action.payload,
      };

    case ActivityLogActionTypes.GetActivityLogDetails:
      return {
        ...state,
        activityLogDetailsData: action.payload,
      };

    default: {
      return state;
    }
  }
};

export { ActivityLogReducer };
